export default __webpack_public_path__ + "static/media/SN.01041f1a.svg";